// src/App.jsx
import { useState } from "react";
import { useLocation } from "react-router-dom";

// Layout
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";

// Chat interne
import ChatWindow from "./components/chat/ChatWindow";
import ChatButton from "./components/chat/ChatButton";

import "./App.css";
import { useAuth } from "./lib/auth";
// Hook de thème
import { useTheme } from "./lib/ThemeContext";

// Routes index
import AppRoutes from "./routes/AppRoutes";

function App() {
  const [isChatVisible, setIsChatVisible] = useState(false);
  const { isAuthenticated, user } = useAuth();

  return (
    <div className="app-shell min-h-screen flex flex-col transition-colors duration-200">
      <Header />

      <main className="app-main flex-grow text-gray-900 dark:text-white transition-colors duration-200">
        <AppRoutes />
      </main>

      {/* --- Chat Interne (Membres & Admin) --- */}
      {isChatVisible ? (
        <ChatWindow onClose={() => setIsChatVisible(false)} />
      ) : (
        isAuthenticated &&
        (user?.role === "admin" || user?.role === "member") && (
          <ChatButton
            toggleChat={() => setIsChatVisible(!isChatVisible)}
            isChatOpen={isChatVisible}
          />
        )
      )}

      {/* --- Footer --- */}
      <Footer />
    </div>
  );
}

export default App;
